import {Pipe, PipeTransform} from '@angular/core';
import {Ticket} from '../../model/Ticket';

@Pipe({
  name: 'state',
  standalone: true
})
export class StatePipe implements PipeTransform {

  transform(tickets: Ticket[], state: string): Ticket[] {
    if (state === 'open') {
      return tickets.filter(t => !t.state.startsWith('4'));
    } else if (state === 'closed') {
      return tickets.filter(t => t.state.startsWith('4'));
    } else {
      return tickets;
    }
  }
}
